import { ReactNode } from 'react';

import Paragraph from '../../../components/Paragraph/Paragraph';
import IllustratedMessage from '../IllustratedMessage/IllustratedMessage';

import emptyIcon from './graphics/empty.svg?raw';

type NoContentMessageProps = {
    variant?: 'subtle' | 'block';
    children: ReactNode;
};

const NoContentMessage = ({
    children,
    variant = 'subtle',
}: NoContentMessageProps) => {
    if (variant === 'subtle') {
        return <Paragraph subdued>{children}</Paragraph>;
    }

    return <IllustratedMessage icon={emptyIcon}>{children}</IllustratedMessage>;
};

export default NoContentMessage;
